export default __webpack_public_path__ + "static/media/phone.2b7124b3.svg";